(function shopifyChatDragModule() {
  // Search: shopify-chat-proxy - keeps the custom chat launcher snapped inside the viewport.
  var storageKey = 'bcShopifyChatLauncherPosition';
  var positionStyleId = 'bc-shopify-chat-position-rule';
  var svgNamespace = 'http://www.w3.org/2000/svg';
  var hostSelector = '#ShopifyChat, inbox-online-store-chat, #shopify-chat';
  var launcherSelector = [
    'button.chat-toggle',
    '.chat-toggle',
    'button[aria-label*="Chat"]',
    'button[aria-label*="chat"]',
    '[role="button"][aria-label*="Chat"]',
    '[role="button"][aria-label*="chat"]'
  ].join(',');
  var dialogSelector = [
    '[role="dialog"]',
    '[aria-modal="true"]',
    '[class*="chat-window"]',
    '[class*="ChatWindow"]',
    '[class*="conversation"]',
    '[class*="Conversation"]'
  ].join(',');
  var proxyClass = 'bc-shopify-chat-proxy';
  var proxyHiddenClass = 'bc-shopify-chat-proxy--hidden';
  var hostHiddenClass = 'bc-shopify-chat-host-hidden';
  var draggingClass = 'bc-shopify-chat-proxy--dragging';
  var iconClass = 'bc-shopify-chat-proxy__icon';
  var positionRuleSelector = '.' + proxyClass;
  var state = {
    documentObserver: null,
    drag: null,
    host: null,
    launcher: null,
    position: null,
    proxy: null,
    refreshTimer: null,
    resizeReady: false,
    retryCount: 0,
    shadowObserver: null,
    suppressClickUntil: 0
  };
  var fallbackSize = 64;
  var minimumVisibleSize = 20;
  var dialogMinimumWidth = 220;
  var dialogMinimumHeight = 180;
  var launcherMinimumSize = 40;
  var launcherMaximumWidth = 220;
  var launcherMaximumHeight = 120;
  var viewportEdgeOffset = 12;
  var fallbackViewportSize = 320;
  var dragStartThreshold = 5;
  var suppressClickDuration = 350;
  var refreshDelay = 80;
  var retryDelay = 200;
  var retryLimit = 50;
  var openSyncDelays = [80, 250, 600, 1200];

  function getPoint(event) {
    var source = event;

    if (event.touches && event.touches.length) {
      source = event.touches[0];
    } else if (event.changedTouches && event.changedTouches.length) {
      source = event.changedTouches[0];
    }

    if (typeof source.clientX === 'undefined' || typeof source.clientY === 'undefined') {
      return null;
    }

    return {
      x: source.clientX,
      y: source.clientY
    };
  }

  function readSavedPosition() {
    var position;

    try {
      position = JSON.parse(window.localStorage.getItem(storageKey));
    } catch (e) {
      position = null;
    }

    if (!position || !isFinite(position.left) || !isFinite(position.top)) {
      return null;
    }

    position.edge = normalizeEdge(position.edge) || getNearestEdge(position);

    return position;
  }

  function savePosition(position) {
    if (!position) {
      return;
    }

    try {
      window.localStorage.setItem(storageKey, JSON.stringify(position));
    } catch (e) {}
  }

  function normalizeEdge(edge) {
    if (edge === 'left' || edge === 'right' || edge === 'top' || edge === 'bottom') {
      return edge;
    }

    return null;
  }

  function addClass(element, className) {
    if (element && element.classList) {
      element.classList.add(className);
    }
  }

  function removeClass(element, className) {
    if (element && element.classList) {
      element.classList.remove(className);
    }
  }

  function setClass(element, className, enabled) {
    if (element && element.classList) {
      element.classList.toggle(className, enabled);
    }
  }

  function getViewport() {
    return {
      height: window.innerHeight || document.documentElement.clientHeight || fallbackViewportSize,
      width: window.innerWidth || document.documentElement.clientWidth || fallbackViewportSize
    };
  }

  function getVisibleRect(element) {
    var rect;
    var style;

    if (!element || !element.getBoundingClientRect) {
      return null;
    }

    rect = element.getBoundingClientRect();
    style = window.getComputedStyle ? window.getComputedStyle(element) : null;

    if (rect.width < minimumVisibleSize || rect.height < minimumVisibleSize) {
      return null;
    }

    if (style && (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0')) {
      return null;
    }

    return rect;
  }

  function getProxySize() {
    var rect = state.proxy ? state.proxy.getBoundingClientRect() : null;

    return {
      height: rect && rect.height ? rect.height : fallbackSize,
      width: rect && rect.width ? rect.width : fallbackSize
    };
  }

  function clampPosition(position) {
    var edge = viewportEdgeOffset;
    var size = getProxySize();
    var viewport = getViewport();
    var maxLeft = Math.max(edge, viewport.width - size.width - edge);
    var maxTop = Math.max(edge, viewport.height - size.height - edge);

    return {
      left: Math.min(Math.max(edge, position.left), maxLeft),
      top: Math.min(Math.max(edge, position.top), maxTop)
    };
  }

  function getNearestEdge(position) {
    var clamped = clampPosition(position);
    var size = getProxySize();
    var viewport = getViewport();
    var distances = [
      { name: 'left', value: clamped.left },
      { name: 'right', value: viewport.width - clamped.left - size.width },
      { name: 'top', value: clamped.top },
      { name: 'bottom', value: viewport.height - clamped.top - size.height }
    ];
    var nearest = distances[0];
    var i;

    for (i = 1; i < distances.length; i += 1) {
      if (distances[i].value < nearest.value) {
        nearest = distances[i];
      }
    }

    return nearest.name;
  }

  // Search: shopify-chat-edge-snap - preserve the selected viewport edge across resizes.
  function positionOnEdge(position, edgeName) {
    var clamped = clampPosition(position);
    var edge = viewportEdgeOffset;
    var normalizedEdge = normalizeEdge(edgeName) || getNearestEdge(clamped);
    var size = getProxySize();
    var viewport = getViewport();
    var maxLeft = Math.max(edge, viewport.width - size.width - edge);
    var maxTop = Math.max(edge, viewport.height - size.height - edge);

    if (normalizedEdge === 'left') {
      clamped.left = edge;
    } else if (normalizedEdge === 'right') {
      clamped.left = maxLeft;
    } else if (normalizedEdge === 'top') {
      clamped.top = edge;
    } else {
      clamped.top = maxTop;
    }

    clamped = clampPosition(clamped);
    clamped.edge = normalizedEdge;

    return clamped;
  }

  function snapPosition(position) {
    var clamped = clampPosition(position);

    return positionOnEdge(clamped, getNearestEdge(clamped));
  }

  // Search: shopify-chat-position-rule - writes drag coordinates to one managed stylesheet, not inline element styles.
  function writePositionRule(position) {
    var style = document.getElementById(positionStyleId);
    var left = Math.round(position.left);
    var top = Math.round(position.top);

    if (!style) {
      style = document.createElement('style');
      style.id = positionStyleId;
      document.head.appendChild(style);
    }

    style.textContent = positionRuleSelector +
      '{--bc-shopify-chat-left:' + left + 'px;--bc-shopify-chat-top:' + top + 'px;}';
  }

  function applyPosition(position) {
    var clamped;

    if (!state.proxy) {
      return null;
    }

    clamped = clampPosition(position);
    clamped.edge = normalizeEdge(position.edge) ||
      (state.position ? normalizeEdge(state.position.edge) : null) ||
      getNearestEdge(clamped);
    state.position = clamped;
    writePositionRule(clamped);

    return clamped;
  }

  function getDefaultPosition() {
    var launcherRect = getVisibleRect(state.launcher);
    var position;
    var size = getProxySize();
    var viewport = getViewport();

    if (launcherRect) {
      position = {
        left: launcherRect.left,
        top: launcherRect.top
      };
      position.edge = getNearestEdge(position);

      return position;
    }

    return {
      left: viewport.width - size.width - viewportEdgeOffset,
      top: viewport.height - size.height - viewportEdgeOffset,
      edge: 'right'
    };
  }

  function isOpenValue(value) {
    return value === '' || value === 'true' || value === '1';
  }

  function hasOpenAttribute(element) {
    if (!element || !element.getAttribute) {
      return false;
    }

    return isOpenValue(element.getAttribute('is-open')) ||
      isOpenValue(element.getAttribute('isopen')) ||
      isOpenValue(element.getAttribute('data-is-open')) ||
      isOpenValue(element.getAttribute('aria-expanded'));
  }

  function getElementText(element) {
    return [
      element.getAttribute('aria-label') || '',
      element.getAttribute('title') || '',
      element.className || '',
      element.textContent || ''
    ].join(' ').toLowerCase();
  }

  function isExcludedControl(element) {
    var text = getElementText(element);

    return text.indexOf('close') !== -1 || text.indexOf('minimize') !== -1;
  }

  function isLikelyLauncher(element) {
    var rect;
    var text;

    if (!getVisibleRect(element) || isExcludedControl(element)) {
      return false;
    }

    rect = element.getBoundingClientRect();
    text = getElementText(element);

    if (text.indexOf('chat') !== -1 || text.indexOf('message') !== -1) {
      return true;
    }

    return rect.width >= launcherMinimumSize &&
      rect.height >= launcherMinimumSize &&
      rect.width <= launcherMaximumWidth &&
      rect.height <= launcherMaximumHeight;
  }

  function findLauncherInRoot(root) {
    var candidates;
    var i;

    if (!root || !root.querySelectorAll) {
      return null;
    }

    candidates = root.querySelectorAll(launcherSelector);

    for (i = 0; i < candidates.length; i += 1) {
      if (isLikelyLauncher(candidates[i])) {
        return candidates[i];
      }
    }

    for (i = 0; i < candidates.length; i += 1) {
      if (!isExcludedControl(candidates[i])) {
        return candidates[i];
      }
    }

    candidates = root.querySelectorAll('button, [role="button"], a[href]');

    for (i = 0; i < candidates.length; i += 1) {
      if (isLikelyLauncher(candidates[i])) {
        return candidates[i];
      }
    }

    for (i = 0; i < candidates.length; i += 1) {
      if (!isExcludedControl(candidates[i])) {
        return candidates[i];
      }
    }

    return null;
  }

  function findChatHost() {
    var hosts = document.querySelectorAll(hostSelector);
    var fallback = null;
    var i;

    for (i = 0; i < hosts.length; i += 1) {
      if (hosts[i].shadowRoot) {
        return hosts[i];
      }

      if (!fallback) {
        fallback = hosts[i];
      }
    }

    return fallback;
  }

  function findChatLauncher(host) {
    if (!host) {
      return null;
    }

    if (isCurrentLauncher(host)) {
      return state.launcher;
    }

    return findLauncherInRoot(host.shadowRoot) || findLauncherInRoot(host) || host;
  }

  function isCurrentLauncher(host) {
    var root;

    if (!state.launcher || state.launcher === host || !state.launcher.isConnected) {
      return false;
    }

    root = state.launcher.getRootNode ? state.launcher.getRootNode() : null;

    return root === host.shadowRoot || host.contains(state.launcher);
  }

  function findDialog(host) {
    var dialogs;
    var i;

    if (!host || !host.shadowRoot) {
      return null;
    }

    dialogs = host.shadowRoot.querySelectorAll(dialogSelector);

    for (i = 0; i < dialogs.length; i += 1) {
      if (getVisibleRect(dialogs[i]) &&
        dialogs[i].getBoundingClientRect().width > dialogMinimumWidth &&
        dialogs[i].getBoundingClientRect().height > dialogMinimumHeight) {
        return dialogs[i];
      }
    }

    return null;
  }

  function isChatOpen() {
    return hasOpenAttribute(state.host) || hasOpenAttribute(state.launcher) || !!findDialog(state.host);
  }

  function createSvgPath(pathData) {
    var path = document.createElementNS(svgNamespace, 'path');

    path.setAttribute('d', pathData);

    return path;
  }

  // Search: shopify-chat-proxy-icon - builds the launcher icon without injected HTML strings.
  function createChatIcon() {
    var icon = document.createElement('span');
    var svg = document.createElementNS(svgNamespace, 'svg');

    icon.className = iconClass;
    icon.setAttribute('aria-hidden', 'true');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('focusable', 'false');
    svg.appendChild(createSvgPath('M5.5 17.2A7.8 7.8 0 0 1 4 12.6C4 8 7.8 4.5 12.4 4.5S20.8 8 20.8 12.6 17 20.7 12.4 20.7a9 9 0 0 1-3.7-.8L4.2 21l1.3-3.8Z'));
    svg.appendChild(createSvgPath('M8.2 11h8.1M8.2 14.2h5.4'));
    icon.appendChild(svg);

    return icon;
  }

  function createProxy() {
    var proxy;

    if (state.proxy) {
      return state.proxy;
    }

    proxy = document.createElement('button');
    proxy.type = 'button';
    proxy.className = proxyClass;
    proxy.setAttribute('aria-label', 'Open chat');
    proxy.appendChild(createChatIcon());
    proxy.addEventListener('pointerdown', handleDragStart, true);
    proxy.addEventListener('mousedown', handleDragStart, true);
    proxy.addEventListener('touchstart', handleDragStart, { capture: true, passive: true });
    proxy.addEventListener('click', handleProxyClick, true);
    document.body.appendChild(proxy);
    state.proxy = proxy;

    applyPosition(readSavedPosition() || getDefaultPosition());

    return proxy;
  }

  function setProxyHidden(hidden) {
    if (!state.proxy) {
      return;
    }

    setClass(state.proxy, proxyHiddenClass, hidden);
    state.proxy.hidden = hidden;
  }

  function setHostHidden(hidden) {
    if (!state.host) {
      return;
    }

    setClass(state.host, hostHiddenClass, hidden);
  }

  function syncOpenState() {
    var open = isChatOpen();

    setProxyHidden(open);
    setHostHidden(!open);

    if (!open && state.proxy && !state.position) {
      applyPosition(readSavedPosition() || getDefaultPosition());
    }
  }

  function scheduleOpenSync() {
    var i;

    for (i = 0; i < openSyncDelays.length; i += 1) {
      window.setTimeout(syncOpenState, openSyncDelays[i]);
    }
  }

  function clickNativeLauncher() {
    if (!state.launcher || isChatOpen()) {
      return;
    }

    setHostHidden(false);
    state.launcher.click();
    setProxyHidden(true);
    scheduleOpenSync();
  }

  function handleProxyClick(event) {
    if (state.suppressClickUntil > Date.now()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      return;
    }

    clickNativeLauncher();
  }

  function handleDragStart(event) {
    var point = getPoint(event);
    var rect;

    if (state.drag || !state.proxy || state.proxy.hidden || isChatOpen() || !point) {
      return;
    }

    rect = state.proxy.getBoundingClientRect();
    state.drag = {
      moved: false,
      pointerId: event.pointerId,
      startLeft: rect.left,
      startTop: rect.top,
      startX: point.x,
      startY: point.y
    };

    if (event.type === 'pointerdown' && state.proxy.setPointerCapture) {
      try {
        state.proxy.setPointerCapture(event.pointerId);
      } catch (e) {}
    }

    document.addEventListener('pointermove', handleDragMove, true);
    document.addEventListener('pointerup', handleDragEnd, true);
    document.addEventListener('pointercancel', handleDragEnd, true);
    document.addEventListener('mousemove', handleDragMove, true);
    document.addEventListener('mouseup', handleDragEnd, true);
    document.addEventListener('touchmove', handleDragMove, { capture: true, passive: false });
    document.addEventListener('touchend', handleDragEnd, true);
    document.addEventListener('touchcancel', handleDragEnd, true);
  }

  function handleDragMove(event) {
    var left;
    var point;
    var top;

    if (!state.drag) {
      return;
    }

    point = getPoint(event);

    if (!point) {
      return;
    }

    if (!state.drag.moved &&
      Math.abs(point.x - state.drag.startX) < dragStartThreshold &&
      Math.abs(point.y - state.drag.startY) < dragStartThreshold) {
      return;
    }

    left = state.drag.startLeft + point.x - state.drag.startX;
    top = state.drag.startTop + point.y - state.drag.startY;
    state.drag.moved = true;
    addClass(state.proxy, draggingClass);

    if (event.cancelable) {
      event.preventDefault();
    }

    event.stopPropagation();
    applyPosition({ left: left, top: top });
  }

  function handleDragEnd(event) {
    var position;

    if (!state.drag) {
      return;
    }

    if (state.drag.moved) {
      if (event && event.cancelable) {
        event.preventDefault();
      }

      if (event) {
        event.stopPropagation();
      }

      position = applyPosition(snapPosition(state.position || getDefaultPosition()));
      savePosition(position);
      state.suppressClickUntil = Date.now() + suppressClickDuration;
    }

    if (event && event.type === 'pointerup' && state.proxy.releasePointerCapture) {
      try {
        state.proxy.releasePointerCapture(state.drag.pointerId);
      } catch (e) {}
    }

    removeClass(state.proxy, draggingClass);
    document.removeEventListener('pointermove', handleDragMove, true);
    document.removeEventListener('pointerup', handleDragEnd, true);
    document.removeEventListener('pointercancel', handleDragEnd, true);
    document.removeEventListener('mousemove', handleDragMove, true);
    document.removeEventListener('mouseup', handleDragEnd, true);
    document.removeEventListener('touchmove', handleDragMove, true);
    document.removeEventListener('touchend', handleDragEnd, true);
    document.removeEventListener('touchcancel', handleDragEnd, true);
    state.drag = null;
  }

  function observeShadowRoot(root) {
    if (!root || state.shadowObserver) {
      return;
    }

    state.shadowObserver = new MutationObserver(handleMutation);
    state.shadowObserver.observe(root, {
      attributes: true,
      childList: true,
      subtree: true
    });
  }

  function bindChat() {
    state.host = findChatHost();
    state.launcher = findChatLauncher(state.host);

    if (!state.host || !state.launcher) {
      return false;
    }

    if (state.host.shadowRoot) {
      observeShadowRoot(state.host.shadowRoot);
    }

    createProxy();
    syncOpenState();

    return state.launcher !== state.host || !state.host.shadowRoot;
  }

  function refresh() {
    if (!bindChat() && state.retryCount < retryLimit) {
      state.retryCount += 1;
      scheduleRefresh(retryDelay);
    }
  }

  function scheduleRefresh(delay) {
    if (state.refreshTimer) {
      window.clearTimeout(state.refreshTimer);
    }

    state.refreshTimer = window.setTimeout(refresh, delay || refreshDelay);
  }

  function handleMutation() {
    state.retryCount = 0;
    scheduleRefresh();
  }

  function handleResize() {
    var position;

    if (state.position) {
      position = applyPosition(positionOnEdge(state.position, state.position.edge));
      savePosition(position);
    }

    syncOpenState();
  }

  function init() {
    if (!window.MutationObserver || !document.body) {
      return;
    }

    refresh();

    if (!state.documentObserver) {
      state.documentObserver = new MutationObserver(handleMutation);
      state.documentObserver.observe(document.documentElement, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'hidden', 'is-open', 'isopen', 'style', 'aria-expanded']
      });
    }

    if (!state.resizeReady) {
      state.resizeReady = true;
      window.addEventListener('resize', handleResize);

      if (window.visualViewport && window.visualViewport.addEventListener) {
        window.visualViewport.addEventListener('resize', handleResize);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
